import { h } from 'preact'; /** @jsx h */

import { useState } from 'preact/hooks';
import './FactsAccordion.scss';
import FactsItem from './FactsItem/FactsItem';

const FactsAccordion = ({
    title,
    href,
    linkText,
    items,
    borderColor = 'secondary',
    bgColor = 'all-white',
    btnColor = 'primary'
}) => {
    const [isOpen, setIsOpen] = useState({ openItem: 0 });

    const handleClick = index => {
        if (isOpen.openItem === index) {
            return setIsOpen({ openItem: -1 });
        }
        setIsOpen({ openItem: index });
    };

    return (
        <div className={`facts-container border-color-${borderColor} bg-color-${bgColor}`}>
            <h3 className="facts-title">{title}</h3>
            <div className="facts">
                {items.map((item, index) => (
                    <FactsItem
                        key={index}
                        isOpen={isOpen.openItem === index}
                        title={item.title}
                        text={item.text}
                        index={index + 1}
                        onClick={() => handleClick(index)}
                    />
                ))}
            </div>
            <a className={`cta-btn color-${btnColor}`} href={href}>
                <span>
                    <span dangerouslySetInnerHTML={{ __html: linkText }} />
                </span>
                <span className="material-symbols-outlined">arrow_forward</span>
            </a>
        </div>
    );
};

export default FactsAccordion;
